export function getDefaultErrorTitle(type, t) {
    switch (type) {
        case 'not-found':
            return t('pageError.titleNotFound');
        case 'access-issue':
            return t('pageError.titleAccessIssue');
        default:
            return t('pageError.title');
    }
}
